<template>
  <div class="article-variety">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>文章分类</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="search">
      <div>
        <el-input placeholder="请输入内容" prefix-icon="el-icon-search" size="small" v-model="key"
          @keyup.enter.native="Query"></el-input>
      </div>
      <div> <el-button type="primary" size="small" @click.native="Query">查询</el-button></div>
      <div class="add"> <el-button type="primary" size="small" @click="centerDialogVisible = true">+ 添加分类</el-button>
      </div>
    </div>
    <div class="list">
      <el-table :data="tableData" style="width: 100%" :row-class-name="tableRowClassName" size="small">
        <el-table-column prop="name" label="分类名称">
        </el-table-column>
        <el-table-column prop="id" label="操作">
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click="editVariety(scope.row.id, scope.row.name)">编辑</el-button>
            <el-button type="danger" size="small" @click="deleteVariety(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="block">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages"
        :page-sizes="[10, 20, 30, 40]" :page-size="limit" layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>

    <el-dialog title="填写分类" :visible.sync="centerDialogVisible" width="400px" center>
      <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入内容" v-model="article_variety">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click.native="submitConfirm()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>


<script>
export default {
  data() {
    return {
      pages: 1,
      limit: 10,
      key: '',
      tableData: [],
      total: 0,
      centerDialogVisible: false,
      article_variety: '',
      edit_variety_id: ''
    }
  },
  methods: {
    getList() {
      this.$get('/v1/admin/label?pages=' + this.pages + '&limit=' + this.limit + '&key=' + this.key + '&type=article', {})
        .then((res) => {
          console.log(res)
          if (res.data.status === 'success') {
            this.tableData = res.data.data.data;
            this.total = res.data.data.total;
          } else {
            this.$msg(res.data.msg)
          }
        });
    },
    Query() {
      this.pages = 1;
      this.getList();
    },
    submitConfirm() {
      if (!this.article_variety) {
        this.$msg('请填写分类名称！');
        return false;
      }
      if (!this.edit_variety_id) {
        this.$post('/v1/admin/label', { name: this.article_variety })
          .then((res) => {
            if (res.data.status === 'success') {
              this.getList();
              this.article_variety = '';
              this.centerDialogVisible = false
            } else {
              this.$msg(res.data.msg)
            }
          });
      } else {
        this.$put('/v1/admin/label', { name: this.article_variety, id: this.edit_variety_id })
          .then((res) => {
            if (res.data.status === 'success') {
              this.getList();
              this.article_variety = '';
              this.edit_variety_id = '';
              this.centerDialogVisible = false
            } else {
              this.$msg(res.data.msg)
            }
          });
      }
    },
    editVariety(id, name) {
      this.edit_variety_id = id;
      this.article_variety = name;
      this.centerDialogVisible = true;
    },
    deleteVariety(id) {
      this.$confirm('确定删除当前分类？', () => {
        this.$delete('/v1/admin/label', { id: id })
          .then((res) => {
            if (res.data.status === 'success') {
              this.getList();
            } else {
              this.$msg(res.data.msg)
            }
          });
      })
    },
    Switch(switch_val) {
      console.log(switch_val)
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return '';
      } else {
        return 'success-row';
      }
    },
    handleSizeChange(val) {
      this.limit = val;
      this.getList()
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.pages = val;
      this.getList()
      console.log(`当前页: ${val}`);
    },
    goTo(path, id) {
      this.$router.push({
        path: path,
        query: {
          id: id
        }
      })
    }
  },
  created() {
    this.getList()
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
  .article-variety
    .el-table .warning-row {
      background: oldlace;
    }

    .el-table .success-row {
      background: #f0f9eb;
    }

    .search
      margin 20px 0
      display flex
      justify-content flex-start
      input
        width 200px
        margin-right 20px
      .add
        padding-left 100px

    .list
      min-height 550px
      border 1px solid #EBEEF5
      .edit_icon
        width 20px
        height 20px
        margin-left 16px
        border 1px solid  #ccc
        border-radius 4px


</style>



// WEBPACK FOOTER //
// src/pages/ArticleVariety/ArticleVariety.vue